import { EManifestWasteUnit } from "encamp-prisma/generated/browser";

/**
 * Human-readable labels for the EPA e-Manifest waste unit codes.
 * G Gallons, K Kilograms, L Liters, M Metric Tons, N Cubic Meters,
 * P Pounds, T Tons (2000 lbs), Y Cubic Yards.
 */
export const EMANIFEST_WASTE_UNIT_LABELS: Record<EManifestWasteUnit, string> = {
  [EManifestWasteUnit.G]: "Gallons",
  [EManifestWasteUnit.K]: "Kilograms",
  [EManifestWasteUnit.L]: "Liters",
  [EManifestWasteUnit.M]: "Metric Tons",
  [EManifestWasteUnit.N]: "Cubic Meters",
  [EManifestWasteUnit.P]: "Pounds",
  [EManifestWasteUnit.T]: "Tons",
  [EManifestWasteUnit.Y]: "Cubic Yards",
};

/**
 * Normalize a raw waste unit string to a valid EManifestWasteUnit code.
 *
 * Trims surrounding whitespace and upper-cases, so a miscased "p" or padded
 * " P " resolves to "P". Returns null when the value is empty or is not a
 * recognized EPA unit code — e.g. free text like "Box" that a reviewer may
 * type into the manifest review form by mistake.
 *
 * qtyUnitOfMeasureCode is a free-form String column, so callers must not
 * assume stored values are valid codes; run them through this first.
 */
export function normalizeEManifestWasteUnit(
  value: string | null | undefined
): EManifestWasteUnit | null {
  if (value == null) return null;
  const normalized = value.trim().toUpperCase();
  if (normalized === "") return null;
  return Object.values(EManifestWasteUnit).find((unit) => unit === normalized) ?? null;
}
